import clsx from 'clsx';

interface IconTitleNumberWrapInputProps {
  text: string;
  children?: React.ReactNode;
  icon: React.ReactNode;
  displayNumber: number | string;
  subDisplayNumber?: number;
  subDisplayText?: string;
}

const IconTitleNumberWrapInput = ({
  text,
  children,
  icon,
  displayNumber,
  subDisplayNumber,
  subDisplayText,
}: IconTitleNumberWrapInputProps) => {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center justify-between gap-14">
        <div className="flex gap-2">
          {icon}
          <p className="text-body">{text}</p>
        </div>
        <div className="flex flex-col">
          <p className={clsx('text-eyebrow-strong min-w-[5rem] text-right', !children && 'text-gray-4')}>
            {displayNumber}
          </p>
          {(subDisplayNumber || subDisplayText) && (
            <p className="whitespace-nowrap text-right text-footnote-sm text-gray-4">
              {subDisplayNumber && `$${subDisplayNumber}`}
              {subDisplayText && `${subDisplayText}`}
            </p>
          )}
        </div>
      </div>
      {children}
    </div>
  );
};

export default IconTitleNumberWrapInput;
